import { createContext } from 'react';

const PushContext = createContext();

export default PushContext;
